import React from 'react';
import { Navigate } from 'react-router-dom';

// The reset flow is now handled end-to-end inside ForgotPassword
// (email → 4-digit code → new password), matching the backend's OTP endpoints.
// The old link-based "/reset-password?token=..." route no longer applies, so we
// redirect any stale links back to the start of the flow.
const ResetPassword = () => <Navigate to="/forgot-password" replace />;

export default ResetPassword;